import { createFileRoute } from '@tanstack/react-router'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { ClientTimeSummary } from '@/components/time/client-time-summary'

export const Route = createFileRoute('/_app/clients/$clientId/temps')({
  component: ClientTimePage,
})

function ClientTimePage() {
  const client = useShellClient()
  return (
    <Frame>
      <ClientTimeSummary client={client} />
    </Frame>
  )
}
